import React from "react";
import { Button } from "primereact/button";
import localeText from "../../../../../locale";
import { formatPrice } from "../../../../../utilities/formatPrice";

const ExtracreditCard = ({ balance, usagePercent, onUseInStore, onStatement }) => {
  const displayBalance = balance != null ? formatPrice(balance) : "0.00";
  const pct = Number(usagePercent);
  const powerLabel =
    Number.isFinite(pct) && pct >= 0
      ? localeText("powerOfUseLabel", { percent: String(Math.round(pct)) })
      : null;

  return (
    <div
      className="card border-round-lg flex flex-column justify-content-between p-4 h-full"
      style={{
        minHeight: "220px",
        border: "1px solid var(--theme-border, #EBEBEB)",
      }}
    >
      <div className="flex align-items-top justify-content-between mb-4">
        <div
          className="flex align-items-center gap-2 border-round-xl p-3"
          style={{ backgroundColor: "color-mix(in srgb, var(--theme-primary) 15%, transparent)" }}
        >
          <i
            className="pi pi-shopping-cart text-xl"
            style={{ color: "var(--theme-primary, #1DAF61)" }}
          />
        </div>
        <div>
          <span
            className="px-3 py-1 border-round-md text-xs font-medium"
            style={{
              backgroundColor: "var(--theme-border, #EBEBEB)",
              color: "var(--theme-text, #262626)",
            }}
          >
            {localeText("consumption")}
          </span>
        </div>
      </div>
      <div className="text-xs font-bold mb-2" style={{ color: "var(--theme-text-muted, #7A869A)" }}>
        {localeText("extracredit").toUpperCase()}
      </div>
      <div className="mb-2">
        <span className="text-2xl font-bold" style={{ color: "var(--theme-text, #344563)" }}>
          {displayBalance}{" "}
          <span
            className="text-sm font-medium"
            style={{ color: "var(--theme-text-muted, #505F79)" }}
          >
            ECR{" "}
          </span>
        </span>
      </div>
      {powerLabel && (
        <div className="text-xs" style={{ color: "var(--theme-text-muted, #7A869A)" }}>
          {powerLabel}
        </div>
      )}
      <hr className="my-4" style={{ borderColor: "var(--theme-border, #EBEBEB)" }} />
      <div className="flex gap-2 flex-wrap">
        <Button
          label={localeText("useInStore")}
          className="p-button-text text-sm flex-1 border-round-md"
          style={{
            backgroundColor: "color-mix(in srgb, var(--theme-primary) 15%, transparent)",
            color: "var(--theme-primary, #1DAF61)",
          }}
          onClick={onUseInStore}
        />
        <Button
          label={localeText("statement")}
          className="p-button-text text-sm flex-1 border-round-md"
          style={{
            border: "1px solid var(--theme-border, #EBEBEB)",
            color: "var(--theme-text-muted, #5C5C5C)",
          }}
          onClick={onStatement}
        />
      </div>
    </div>
  );
};

export default React.memo(ExtracreditCard);
